module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border-medium radius-normal  mb-3 bg-lighter"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center px-3 py-2 border-bottom-light"
  }, [_c('div', {
    staticClass: "font-weight-600 darker py-2 col-sm-6"
  }, [_c('div', {
    staticClass: "row flexGrow1"
  }, [(_vm.widget.editing) ? _c('label', [_vm._v("Name")]) : _vm._e(), _vm._v(" "), (_vm.widget.editing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widget.name),
      expression: "widget.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "Widget Name"
    },
    domProps: {
      "value": (_vm.widget.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widget, "name", $event.target.value)
      }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.widget.name))])])]), _vm._v(" "), (_vm.widget.loading) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.widget.loading) ? _c('div', {
    staticClass: "d-flex"
  }, [(_vm.isCreatingWidget == false) ? _c('div', [(_vm.widget.editing) ? _c('span', {
    staticClass: "bg-color-3 lighter fs-smaller radius-normal py-1 px-2 pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.saveEditedWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-check fs-smaller"
  }), _vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.widget.editing) ? _c('span', {
    staticClass: "bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.cancelEditedWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-close fs-smaller"
  }), _vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (!_vm.widget.editing) ? _c('span', {
    staticClass: "bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.activateEditionMode(_vm.widget)
      }
    }
  }, [(_vm.widget.isLoading) ? _c('span', [_vm._v("\n                        Loading\n                    ")]) : _c('span', [_c('i', {
    staticClass: "ico ico-edit fs-smaller"
  }), _vm._v("Edit\n                    ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "bg-color-6 lightest fs-smaller radius-normal py-1 px-2 pointer",
    on: {
      "click": function($event) {
        return _vm.deletThisWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-delete fs-smaller"
  }), _vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.isCreatingWidget == true) ? _c('div', [_c('span', {
    staticClass: "bg-color-3 lighter fs-smaller radius-normal py-1 px-2 pointer mr-2",
    class: {
      'opacity-50 notAllowed': _vm.validation.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.creatingSaveWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-check fs-smaller"
  }), _vm._v("Save")]), _vm._v(" "), _c('span', {
    staticClass: "bg-dark lighter fs-smaller radius-normal py-1 px-2 pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.creatingWidgetCancelWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-close fs-smaller"
  }), _vm._v("Cancel")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.widget.editing && _vm.widget.categoryProductList) ? _c('div', {
    staticClass: "px-3 py-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('checkbox', {
    model: {
      value: (_vm.widget.isToActiveFutureItems),
      callback: function($$v) {
        _vm.$set(_vm.widget, "isToActiveFutureItems", $$v)
      },
      expression: "widget.isToActiveFutureItems"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Allow new Products/Categories added to inventory to be automatically available in this widget.")])], 1)]), _vm._v(" "), _c('widget-composer', {
    attrs: {
      "productOptions": _vm.productsArr,
      "showInputName": false
    },
    model: {
      value: (_vm.widget),
      callback: function($$v) {
        _vm.widget = $$v
      },
      expression: "widget"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCreatingWidget == false) ? _c('div', [_c('div', {
    staticClass: "fs-small font-weight-600 dark d-flex align-items-center justify-content-between px-3 pt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "border-dark bg-lightest dark fs-smaller radius-normal py-1 px-2 pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.previewWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "far fa-eye fs-smaller"
  }), _vm._v("Preview\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "dark border-dark radius-normal align-items-center px-2 py-1 pointer bg-lightest fs-smaller",
    on: {
      "click": function($event) {
        return _vm.copyWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-notes fs-smaller"
  }), _vm._v("\n                    Copy\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "fs-small position-relative px-3 pb-3 pt-1"
  }, [_vm._v("\n            " + _vm._s(_vm.generateIframeCode(_vm.widget.guid)) + "\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-grow-1"
  }, [_c('h3', [_vm._v("Which options must be displayed in this booking engine?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Preview and embed this code in your website.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-76961948", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76961948"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/widget/widgetEditor.vue
// module id = 1581
// module chunks = 0